import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { DreamSection } from '../components/DreamSection';
import { ProductIntro } from '../components/ProductIntro';
import { HowItWorks } from '../components/HowItWorks';
import { TransformationSection } from '../components/TransformationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingCTA } from '../components/PricingCTA';
import { BuyButton } from '../components/BuyButton';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-pink-200 selection:text-purple-900" data-id="element-254">
      <HeroSection data-id="element-255" />
      <PainSection data-id="element-256" />
      <DreamSection data-id="element-257" />

      {/* Strategic Mid-page CTA 1 */}
      <section className="py-12 bg-white text-center" data-id="element-258">
        <div className="container mx-auto px-4" data-id="element-259">
          <BuyButton data-id="element-260" />
        </div>
      </section>

      <ProductIntro data-id="element-261" />
      <HowItWorks data-id="element-262" />
      <TransformationSection data-id="element-263" />

      {/* Strategic Mid-page CTA 2 */}
      <section className="py-16 bg-[#FFF8F0] text-center" data-id="element-264">
        <div className="container mx-auto px-4" data-id="element-265">
          <p className="text-xl font-bold text-purple-900 mb-6" data-id="element-266">
            ¿Lista para recuperar tu tranquilidad?
          </p>
          <BuyButton text="SÍ, QUIERO EL SISTEMA" data-id="element-267" />
        </div>
      </section>

      <TestimonialsSection data-id="element-268" />
      <BonusSection data-id="element-269" />
      <PricingCTA data-id="element-270" />

      <SocialProofPopup data-id="element-271" />
    </div>;
}